import { MutationTree } from 'vuex'
import { UserState } from '../storeTypes'

const mutations: MutationTree<UserState> = {
  setLoggedin: (state, { uid, isAuthed }) => {
    state.uid = uid
    state.authorized = !!isAuthed
    state.authState = 'done'
  },
  setInprogress: (state) => {
    state.uid = null
    state.authorized = false
    state.authState = 'inprogress'
  }
}

export default mutations
